import { Utils } from "@microfrontends/react-components"
import { decrypt } from "../auth/cryptor"
import { IBodyCheckingNumerology, ICareerPathDetail, ICheckingNumerology, IIndustry, ILevel, TNumerologyDetail, IRulingNumber, TResponeData, TUserInfoInNumerlogy, EPageTypeFamousPeople, IFamousPeople, ICronJobNumerology, IDataChartNumerology, EColorChart } from "./@type"


const apiDomain = `${process.env.API_DOMAIN}/api-gateway/v1.0`
export class NumerologyApi {
    constructor() {
    }

    public async getIndustryList(): Promise<IIndustry[] | null> {
        try {
            const response = await fetch(`${apiDomain}/industry`, {
                method: "GET",

            })
            if (response.status === 200) {
                const json: TResponeData<IIndustry[]> = await response.json()
                return json.data
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    public async getLevelList(industryId: number): Promise<ILevel[] | null> {
        try {
            const response = await fetch(`${apiDomain}/level?industryId=${industryId}`, {
                method: "GET",

            })
            if (response.status === 200) {
                const json: TResponeData<ILevel[]> = await response.json()
                return json.data
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    public async checkNumerology(token: string, body: IBodyCheckingNumerology): Promise<ICheckingNumerology | null> {
        try {
            const decryptToken = decrypt(token)
            const response = await fetch(`${apiDomain}/checking-numerology`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${decryptToken}`,
                    "Accept-Language": "vi"
                },
                body: JSON.stringify(body)
            })
            if (response.status === 200) {
                const json: TResponeData<ICheckingNumerology> = await response.json()
                return json.data
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    public async getNumerologyDetail(token: string): Promise<TNumerologyDetail & TUserInfoInNumerlogy | null> {
        try {
            const decryptToken = decrypt(token)
            const response = await fetch(`${apiDomain}/numerology-detail`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${decryptToken}`,
                    "Accept-Language": "vi"
                },
            })
            if (response.status === 200) {
                const json: TResponeData<TNumerologyDetail & TUserInfoInNumerlogy> = await response.json()
                return json.data
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    public async getRulingNumberList(): Promise<IRulingNumber[] | null> {
        try {
            const response = await fetch(`${apiDomain}/numerology-list`, {
                method: "GET",
            })
            if (response.status === 200) {
                const json: TResponeData<IRulingNumber[]> = await response.json()
                return json.data
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    public async getCareerPathDetail(token: string, industryId: number, levelAlias: string): Promise<ICareerPathDetail | null> {
        try {
            const decryptToken = decrypt(token)
            const response = await fetch(`${apiDomain}/career-path?industryId=${industryId}&levelAlias=${levelAlias}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${decryptToken}`
                },
            })
            if (response.status === 200) {
                const json: TResponeData<ICareerPathDetail> = await response.json()
                return json.data
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    public async getFamousPeople(pageType?: EPageTypeFamousPeople, rulingNumber?: number): Promise<IFamousPeople[] | null> {
        try {
            const response = await fetch(`${apiDomain}/famous-people?${Utils.objToQueryStr({
                ...!rulingNumber ? undefined : { rulingNumber: rulingNumber },
                ...!pageType ? undefined : { pageType: pageType },
            })}`, {
                method: "GET",

            })
            if (response.status === 200) {
                const json: TResponeData<IFamousPeople[]> = await response.json()
                return json.data
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }

    public async getJobNumerologyByJobCategory(rulingNumber: number): Promise<IDataChartNumerology[] | null> {
        try {
            const response = await fetch(`${apiDomain}/numerology-by-industry?rulingNumber=${rulingNumber}`, {
                method: "GET",
            })
            if (response.status === 200) {
                const data: IDataChartNumerology[] = []
                const json: TResponeData<ICronJobNumerology[]> = await response.json()
                if (json.data) {

                    let total: number = 0
                    for (const elm of json.data) {

                        if (elm.rate !== null) {
                            total += elm.rate
                        }
                    }
                    json.data.push({
                        industryId: 0,
                        industryName: "Khác",
                        industryNameEn: "Other",
                        rate: 100 - total
                    })
                    json.data.forEach((elm, i) => {
                        data.push({
                            ...elm,
                            color: EColorChart[i]
                        })
                    })

                    return data
                }
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }
    public async getJobNumerologyByJobCategoryV2(rulingNumber: number): Promise<IDataChartNumerology[] | null> {
        try {
            const response = await fetch(`${apiDomain}/numerology-by-industry?rulingNumber=${rulingNumber}`, {
                method: "GET",
            })
            if (response.status === 200) {
                const data: IDataChartNumerology[] = []
                const json: TResponeData<ICronJobNumerology[]> = await response.json()
                if (json.data) {
                    json.data.forEach((elm, i) => {
                        data.push({
                            ...elm,
                            color: EColorChart[i]
                        })
                    })
                    return data
                }
                return null
            }
            return null
        } catch (error) {
            console.error(error)
            return null
        }
    }
}
export default new NumerologyApi();
